<template>
  <div id="app">
    <!--对话框组件-->
    <diaLogIos ref="diaLogIos" v-show="diaLogIos" :diaLogIos="diaLogIos" :setDiaLog="setDiaLog"
               @diaLogClick="diaLogClick"></diaLogIos>
    <sheet :sheet="sheet" :sheetTitle="sheetTitle" :sheetLs="sheetLs" @cancel_sheet="sheetToggle"
           @sel_sheet="sel_sheet"></sheet>
    <loading v-show="loading"></loading>
    <success v-show="success" :successTips="successTips"></success>
    <router-view ref="child"
                 @loadingHide="loadingHide"
                 @loadingShow="loadingShow"
                 @successShow="successShow"
                 @set_diaLog="set_diaLog"
                 @sheetToggle="sheetToggle"
                 @sel_sheet="sel_sheet"
                 v-wechat-title='wechatTitle'
    />
  </div>
</template>

<script>
  import sheet from '@/components/actionSheet'
  import loading from '@/components/loadingToast'
  import success from '@/components/successToast'
  import diaLogIos from '@/components/diaLog'
  import {webToast} from "./assets/js/alertPopShow";

  export default {
    name: 'App',
    components: {
      loading,
      success,
      sheet,
      diaLogIos
    },
    data() {
      return {
        diaLogIos: false,
        sheet: false,
        loading: false,//加载框
        success: false,//成功框
        successTips: '',//成功提示
        sheetTitle: '',
        sheetLs: '',
        setDiaLog: '',
        uploadShow: false,
        show: false,
        face_img: '',
        wechatTitle:false,
      }
    },
    created(){
      var that = this;
      that.wechatTitle = localStorage.getItem('area_name') ? localStorage.getItem('area_name') : '东莞江西商会';
      console.log(that.wechatTitle);
    },
    methods: {
      // 设置对话框内容
      set_diaLog(setDiaLog) {
        var that = this;
        console.log('????');
        that.setDiaLog = setDiaLog;
        that.diaLogIos = true;
      },
      // 对话框点击回调
      diaLogClick(status) {
        var that = this;
        var obj = new Object();
        var o_status = Number(that.tabIndex) + 1;
        that.diaLogIos = false;
        that.$refs.child.diaLog_ctrl(status);
      },
      // 显示隐藏 sheet
      sheetToggle(sheet, sheetTitle, sheetLs) {
        var that = this;
        console.log(sheet,sheetTitle,sheetLs);
        that.sheet = sheet;
        that.sheetTitle = sheetTitle;
        that.sheetLs = sheetLs;
      },
      // 选择 sheet
      sel_sheet(index){
        var that = this;
        that.sheetToggle(false,'','');
        that.$refs.child.sel_sheet(index);//调用子组件方法
      },
      //      隐藏加载框
      loadingHide() {
        this.loading = false;
      },
//      显示加载框
      loadingShow() {
        this.loading = true;
      },
//      显示，设置成功提示 并定时关闭
      successShow(msg, time, callback) {
//        调用成功提示框
        console.log('调用成功提示框');
        this.successTips = msg;
        this.success = true;
        setTimeout(() => {
          this.success = false;
          callback && callback();
        }, time)
      },
    }
  }
</script>

<style>
  @import "./assets/css/common.css";
  @import "./assets/css/PopShow.css";

  .weui-dialog__ft {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue